// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import FormHelperText from "@material-ui/core/FormHelperText";

// core components
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import PropTypes from "prop-types";
import React, { createRef } from "react";
import { connect } from "react-redux";
import {
	ADD_POST_CAMPSITE_CHANNEL,
	ADD_POST_CAMPSITE_CITY_CHANNEL,
	DELETE_POST_CAMPSITE_CHANNEL,
	DELETE_POST_CAMPSITE_CITY_CHANNEL
} from "actions/types.js";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle";
import {
	fetchSearchEventCampsiteChannels,
	fetchSearchEventCampsiteCityChannels
} from "actions/channel";
import { bindActionCreators } from "redux";
import ReactTags from "react-tag-autocomplete";

const style = {
	infoText: {
		fontWeight: "300",
		margin: "10px 0 30px",
		textAlign: "center"
	},
	tags: {
		margin: "20px",
		width: "100%"
	},
	mt20: {
		marginTop: "20px"
	},
	...customInputStyle
};

class Step6 extends React.Component {
	sendState() {
		return this.state;
	}

	handleDelete = index => {
		const { dispatch } = this.props;

		if (index >= 0) {
			dispatch({
				type: DELETE_POST_CAMPSITE_CITY_CHANNEL,
				index
			});
		}
	};

	handleAddition = channel => {
		const { dispatch } = this.props;
		dispatch({
			type: ADD_POST_CAMPSITE_CITY_CHANNEL,
			value: channel
		});
	};

	handleChannelDelete = index => {
		const { dispatch } = this.props;

		if (index >= 0) {
			dispatch({
				type: DELETE_POST_CAMPSITE_CHANNEL,
				index
			});
		}
	};

	handleChannelAddition = channel => {
		const { dispatch } = this.props;
		dispatch({
			type: ADD_POST_CAMPSITE_CHANNEL,
			value: channel
		});
	};

	onInput = query => {
		if (query?.length > 2) {
			this.props.fetchSearchEventCampsiteCityChannels(query);
		}
	};

	onInputCommunities = query => {
		if (query?.length > 2) {
			this.props.fetchSearchEventCampsiteChannels(query);
		}
	};

	render() {
		const {
			classes,
			ocamping_city_channels,
			ocamping_city_channels_suggestions,
			ocamping_channels,
			ocamping_channels_suggestions,
			publishedChannelErrorMsg
		} = this.props;

		return (
			<GridContainer justifyContent="center">
				<GridItem xs={12} sm={12}>
					<h4 className={classes.infoText}>
						{
							"Veuillez sélectionner la/les villes, le/les campings où diffuser votre publication sur O’Camping"
						}
					</h4>
				</GridItem>
				<GridItem xs={12} sm={12}>
					<ReactTags
						placeholderText="Villes ..."
						tags={ocamping_city_channels}
						suggestions={ocamping_city_channels_suggestions}
						minQueryLength={3}
						maxSuggestionsLength={10}
						onDelete={this.handleDelete}
						onAddition={this.handleAddition}
						suggestionsFilter={() => true}
						onInput={this.onInput}
						autoFocus={true}
						removeButtonText="Cliquez pour retirer"
						inputAttributes={{
							autoComplete: "new-password"
						}}
					/>
					{publishedChannelErrorMsg && (
						<FormHelperText className={classes.labelRootError}>
							{publishedChannelErrorMsg}
						</FormHelperText>
					)}
				</GridItem>
				<GridItem xs={12} sm={12} className={classes.mt20}>
					<ReactTags
						ref={this.tagsRef2}
						placeholderText="Campings ..."
						tags={ocamping_channels}
						suggestions={ocamping_channels_suggestions}
						minQueryLength={3}
						maxSuggestionsLength={10}
						onDelete={this.handleChannelDelete}
						onAddition={this.handleChannelAddition}
						suggestionsFilter={() => true}
						onInput={this.onInputCommunities}
						autoFocus={true}
						removeButtonText="Cliquez pour retirer"
						inputAttributes={{
							autoComplete: "new-password"
						}}
					/>
					{publishedChannelErrorMsg && (
						<FormHelperText className={classes.labelRootError}>
							{publishedChannelErrorMsg}
						</FormHelperText>
					)}
				</GridItem>
			</GridContainer>
		);
	}
}

Step6.propTypes = {
	classes: PropTypes.object
};

const mapStateToProps = state => {
	const {
		isFetching,
		publishedCities,
		publishedCityErrorMsg,
		suggestions,
		ocamping_city_channels,
		ocamping_city_channels_suggestions,
		ocamping_channels,
		ocamping_channels_suggestions,
		publishedChannelErrorMsg
	} = state.eventReducer;
	return {
		suggestions,
		publishedCities,
		publishedCityErrorMsg,
		isFetching,
		ocamping_city_channels: Object.values(ocamping_city_channels),
		ocamping_city_channels_suggestions: Object.values(
			ocamping_city_channels_suggestions
		),
		ocamping_channels: Object.values(ocamping_channels),
		ocamping_channels_suggestions: Object.values(ocamping_channels_suggestions),
		publishedChannelErrorMsg
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchSearchEventCampsiteCityChannels,
			fetchSearchEventCampsiteChannels
		},
		dispatch
	);
	return { ...actions, dispatch };
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withStyles(style)(Step6));
